import axios from 'axios'
import AppConfig from '../config'
import apiClient from '../Util/apiClient'
import { UserType } from './ActionType'
import setAuthorizationToken from './setAuthorizationToken'

const { API_URL } = AppConfig

export const getUserByToken = (token = localStorage.getItem('NADA_USER')) =>
  function (dispatch) {
    return axios
      .get(`${API_URL}/users/byToken`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        if (res.data.success) {
          setAuthorizationToken(token)
          dispatch({ type: UserType.GET_USER, payload: res.data.result })

          if (res?.data?.result?.language) {
            apiClient
              .get(`translations/get-translations-by-language/${res.data.result.language}`)
              .then(({ data }) => {
                if (data?.result) {
                  dispatch({ type: 'SET_USER_REDUCER', payload: { translations: data?.result } })
                }
              })
          }

          return res.data.result
        }

        return undefined
      })
      .catch(() => {
        localStorage.removeItem('NADA_USER')
      })
  }
